// extracted by mini-css-extract-plugin
export var cardHeader = "_gv-0";
export var reorderHandle = "_gv-3";
export var titleArea = "_gv-1";
export var titleAreaWithHandle = "_gv-2";